export const COUNTDOWN = '{COUNTDOWN}';
/*
    These values are being returned from the homedelivery-promise-service:
    DELIVERED_TOMORROW = NEXT_DAY
    NAMED_DAY_DELIVERED_TOMORROW = NAMED_DAY | PICKUP_POINT | COLLECT_HQ
 */
export const ENABLED_DELIVERY_PROMISES = ['NEXT_DAY', 'NAMED_DAY', 'PICKUP_POINT', 'COLLECT_HQ'];
